(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("classnames"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "classnames", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["rcm-mobile"] = factory(require("react"), require("classnames"), require("react-dom"));
	else
		root["rcm-mobile"] = factory(root["React"], root["classnames"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__8__) {
return 